<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Refresh Your IPSAT 2.0 Report</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()" [disabled]="isSubmitting">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Generating state: replaces the normal modal body while the backend
     re-runs the engine + AI personalization (~15–30s). -->
<div class="modal-body text-center p-xl" *ngIf="isGeneratingReport">
  <i class="fa fa-magic fa-3x text-primary-2 m-b-md" style="animation: pulse 1.5s ease-in-out infinite;"></i>
  <h4 class="font-bold m-b-sm">Refreshing your personalized report…</h4>
  <p class="text-muted m-b-lg" style="max-width: 420px; margin-left: auto; margin-right: auto;">
    We're re-analyzing your archetype pattern against your updated statements and
    composing fresh insights. This usually takes about 15 to 30 seconds.
  </p>
  <div class="progress" style="height: 6px; max-width: 300px; margin: 0 auto 16px;">
    <div class="progress-bar progress-bar-striped active" style="width: 100%;"></div>
  </div>
  <p class="text-muted text-sm">
    <i class="fa fa-info-circle"></i>&nbsp;Please don't close this window.
  </p>
  <style>
    @keyframes pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.7; transform: scale(1.08); }
    }
  </style>
</div>

<div class="modal-body" *ngIf="!isGeneratingReport">
  <p class="m-b-md">
    You've updated your IPSAT 1.0 self-authored statements since your IPSAT 2.0
    Archetype Report was generated. Refresh your report to re-run it against your
    latest answers.
  </p>

  <!-- Pricing -->
  <div class="hpanel m-b-md" *ngIf="price">
    <div class="panel-body">
      <div class="row">
        <div class="col-sm-8">
          <h5>Report Refresh</h5>
          <p class="text-muted" *ngIf="appliedDiscount">
            <i class="fa fa-tag text-success"></i>&nbsp;
            Discount applied: <strong>{{ appliedDiscount }}</strong>
            <a href="javascript:void(0)" (click)="removeDiscount()" class="text-danger m-l-sm">
              <i class="fa fa-times"></i> Remove
            </a>
          </p>
        </div>
        <div class="col-sm-4 text-right">
          <h3 class="font-bold text-success" *ngIf="price.currencyQuantity > 0">
            <app-nexleader-currency
              [currencyCode]="price.currencyCode"
              [currencyQuantity]="price.currencyQuantity">
            </app-nexleader-currency>
          </h3>
          <h3 class="font-bold text-success" *ngIf="price.currencyQuantity <= 0">
            FREE
          </h3>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div class="text-center p-lg" *ngIf="isLoadingPrice">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p class="m-t-sm">Loading price...</p>
  </div>

  <!-- Discount / coach comp code (optional) -->
  <div class="m-b-md" *ngIf="!appliedDiscount && price">
    <label class="control-label">Have a code from your coach?</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Enter code (optional)"
        [(ngModel)]="discountCode"
        (keyup.enter)="applyDiscount()"
        autocomplete="off"
        autocapitalize="characters"
      />
      <span class="input-group-btn">
        <button class="btn btn-default" type="button" (click)="applyDiscount()">
          Apply
        </button>
      </span>
    </div>
    <small class="text-danger" *ngIf="discountError">{{ discountError }}</small>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger m-t-md m-b-none">
    <i class="fa fa-exclamation-circle"></i>&nbsp;&nbsp;{{ errorMessage }}
  </div>

  <p class="text-muted m-t-md m-b-none text-base">
    Refreshing takes about 15-30 seconds while we re-run the personalized
    sections of your report. Don't close this tab while it's running.
  </p>
</div>

<div class="modal-footer" *ngIf="!isGeneratingReport">
  <button type="button" class="btn btn-default" (click)="close()" [disabled]="isSubmitting">Cancel</button>
  <button
    type="button"
    class="btn btn-success"
    (click)="submit()"
    [disabled]="!price || isLoadingPrice || isSubmitting"
  >
    <span *ngIf="!isSubmitting">
      <i class="fa fa-refresh"></i>&nbsp;&nbsp;
      <span *ngIf="price && price.currencyQuantity > 0">Pay &amp; Refresh</span>
      <span *ngIf="price && price.currencyQuantity <= 0">Refresh Report</span>
    </span>
    <span *ngIf="isSubmitting">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Processing…
    </span>
  </button>
</div>
